import { useMemo } from 'react';
import {
  calculateVisiblePages,
  PageItem,
} from 'src/components/DataTable/components/DataTablePagination/Pagination/hooks/usePaginationPages.utils';

interface UsePaginationPagesParams {
  currentPage: number;
  totalPages: number;
}

export interface UsePaginationPagesResult {
  pages: PageItem[];
  totalPages: number;
}

export const usePaginationPages = ({
  currentPage,
  totalPages,
}: UsePaginationPagesParams): UsePaginationPagesResult => {
  const pages = useMemo(
    () => calculateVisiblePages(currentPage, totalPages),
    [currentPage, totalPages]
  );

  return { pages, totalPages };
};
